/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'profile': {
    width: 66,
    height: 66,
    viewBox: '0 0 66 66',
    data: `<defs><clipPath id="svgicon_profile_a"><path pid="0" d="M0 0h66v66H0z"/></clipPath></defs><g clip-path="url(#svgicon_profile_a)"><path pid="1" data-name="Profiel button" d="M65.501 33A32.5 32.5 0 0033.001.5 32.5 32.5 0 00.501 33a32.5 32.5 0 0032.5 32.5 32.5 32.5 0 0032.5-32.5zM40.79 21.553a8.1 8.1 0 01-8.1 8.1 8.1 8.1 0 01-8.1-8.1 8.1 8.1 0 018.1-8.1 8.1 8.1 0 018.1 8.1zm7.365 29.216H17.219v-8.45a8.245 8.245 0 018.244-8.245h14.441a8.249 8.249 0 018.249 8.249z" _fill="none" _stroke="#000" stroke-width="1.189"/></g>`
  }
})
/* tslint:enable */
